const config = {
  state: {
    routerState: 0,
    directControl: true
  },
  getters: {
    getRouterState(state) {
      return state.routerState
    },
    getDirectControl(state) {
      return state.directControl;
    }
  },
  mutations: {
    addRouter(state) {
      state.routerState++;
    },
    delRouter(state) {
      state.routerState--;
    },
    changeDirection(state, bState) {
      state.directControl = bState;
    }

  },
  actions: {

  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/modules/watchRouter.js